import { getApi } from '../../../utils/api'

export function getUserProfileLogEvents({ profile_id, ...params }) {
  return getApi({
    endpoint: `api/profile/${profile_id}/log-events/`,
    params,
  })
}
